<template>
    <div class="limiter">
        <div class="container-login100">
             <div class="refTitleWrap">
                <img width="151" height="38"  src="/static/assets/images/dwerve-title2.png" class="img-fluid dwerve-logo" alt="dwerve">
                <h2>Backer Referral Program</h2>
            </div>
			<div class="wrap-login100">
				<div class="login100-form validate-form">
					<span class="login100-form-title">
						Select Pledge Tier
					</span>

					<div class="wrap-input100 validate-input" >
						<select v-model="pledgeTier" id="tiers" name="tiers" class="ui-select custom-select">
                            <option value="Tinkerer" style="background:#fff;" selected>$15 - Tinkerer (Game)</option>
                            <option value="Digital Tinkerer">$25 - Digital Tinkerer (Digital Bundle)</option>
                            <option value="Bug Hunter">$40 - Bug Hunter (Beta Access)</option>
                            <option value="Apprentice">$60 - Apprentice (Pick 1 Physical Reward)</option>
                            <option value="Artificer">$90 - Artificer (Pick 2 Physical Rewards)</option>
                            <option value="Elite Artificer">$150 - Elite Artificer (Swag Bundle + Statue)</option>
                            <option value="Warsmith">$350 - Warsmith (Hoodie + Monument)</option>
                            <option value="Elite Warsmith">$600 - Elite Warsmith (Villager NPC Designer)</option>
                            <option value="Heroic Warsmith">$800 - Heroic Warsmith (Warrior NPC Designer)</option>
                             <option value="Legendary Warsmith">$1000 - Legendary Warsmith (Enemy Designer)</option>
                            <option value="Warsmith General">$2500 - Warsmith General (Turret Designer)</option>
                            <option value="Warsmith Supreme">$5000 - Warsmith Supreme (Boss Designer)</option>
                        </select><i class="fas fa-chevron-down"></i>
					</div>
					<div class="container-login100-form-btn">
						<button class="login100-form-btn" @click="updateTier()">
							Submit
                            <i class="fa arrow-right" aria-hidden="true"></i>
						</button>
					</div>

				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Router from '../../router';
import YOURLS from 'yourls-api';
import axios from 'axios';

export default {
    data: function() {
    return {
        pledgeTier: "$15 - Tinkerer (Game)",
        shortUrl: ""
    };
  },
  methods: {
     ...mapActions(['setTier']),
   async updateTier() {
        const updatedUser = {
                id: this.$store.state.referrals.user.id,
                pledgeTier: this.pledgeTier,
          }

        await this.setTier(updatedUser);
        document.cookie = `refProgramId=${this.$store.state.referrals.user.id}; expires= Thu, 21 Aug 2021 20:00:00 UTC; path=/ `
        Router.push({ name: 'ReferralDashboard'})
    },
    getCookie(name){
            var cookieArr = document.cookie.split(";");
            for(var i = 0; i < cookieArr.length; i++) {
                var cookiePair = cookieArr[i].split("=");
                if(name == cookiePair[0].trim()) {
                    return decodeURIComponent(cookiePair[1]);
                }
            }
            return null;
        }
  },
  mounted(){
    var cookieID = this.getCookie("refProgramId");
    if(cookieID != null){
           Router.push({ name: 'ReferralDashboard', params: { id: cookieID} })
    }
  }
}
</script>


<style scoped>
.refTitleWrap {
    margin-bottom: -10px;
    width: 100%;
    text-align: center;
    max-width: 586px;
    background: linear-gradient(-135deg, #202a33, #18354e);
    border-radius: 10px 10px 0px 0px;
    padding: 22px;
    position: relative;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
}
.refTitleWrap h2 {
    font-family: 'Titillium Web', sans-serif;
    font-size: 32px;
    color: #fff;
    margin-top: 0;
    margin-bottom: 10px;
    text-shadow: 1px 1px 2px #1a3b84;
}
.limiter {
    width: 100%;
    margin: 0 auto;
}
.login100-pic {
   width: 100%;
    max-width: 600px;
}
.container-login100 {
    width: 100%;
    min-height: 100vh;
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #9053c7;
    background: linear-gradient(-135deg, #2a5384, #4297c6);
}
.wrap-login100 {
   width: 100%;
    max-width: 586px;
    background: #fff;
    border-radius: 10px;
    height: 300px;
    align-content: center;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.login100-pic img {
    max-width: 100%;
}
.login100-form {
    width: 80%;
}
.login100-form-title {
    font-family: 'Titillium Web', sans-serif;
    font-size: 22px;
    color: #333333;
    line-height: 1.2;
    text-align: left;
    width: 100%;
    display: block;
    padding-bottom: 25px;
}
.input100 {
    font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #666666;
    display: block;
    width: 100%;
    background: #e6e6e663;
    border-bottom: 1px solid #1dd18b;
    height: 50px;
    border-radius: 25px;
    padding: 0 30px 0 30px;
}
.focus-input100 {
    display: block;
    position: absolute;
    border-radius: 25px;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 0px 0px;
    color: rgba(87,184,70, 0.8);
}
.symbol-input100 {
    font-size: 15px;
    display: flex;
    align-items: center;
    position: absolute;
    border-radius: 25px;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-left: 35px;
    pointer-events: none;
    color: #666666;
    transition: all 0.4s;
}
.validate-input {
    position: relative;
}
.wrap-input100 {
    position: relative;
    width: 100%;
    z-index: 1;
    margin-bottom: 10px;
}
.login100-form-btn {
    font-family: Digitalt;
       font-size: 25px;
    border: none;
    line-height: 1.5;
    color: #fff;
    text-transform: uppercase;
    width: 100%;
    height: 44px;
    border-radius: 36px;
    background: linear-gradient(-135deg, #1fd28d, #05ce78);
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    align-items: center;
    padding: 0 25px;
    transition: all 0.4s;
    box-shadow: 7px 7px 28px 0 rgb(0 0 0 / 21%);
}
ul.steps {
    display: flex;
    position: absolute;
    list-style-type: none;
    margin: 0;
    padding: 0;
    background-color: #fff;
    text-align: center;
}
.steps li {
    display: inline-block;
    margin: 20px;
    color: #ccc;
    padding-bottom: 5px;
}
.steps li.is-active {
    border-bottom: 1px solid #3498db;
    color: #3498db;
}
select#tiers {
    font-size: 15px;
    border: none;
    line-height: 1.5;
    color: #666666;
    display: block;
    width: 100%;
    background: #e6e6e663;
    border-bottom: 1px solid #1dd18b;
    height: 50px;
    border-radius: 25px;
    padding: 0 61px 0 30px;
}
select::-ms-expand {
    display: none;
}
.ui-select{width: 100%}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {	display: none; }
select{
    -webkit-appearance: none;
    appearance: none;
}
@-moz-document url-prefix(){
	.ui-select{border: 1px solid #CCC; border-radius: 4px; box-sizing: border-box; position: relative; overflow: hidden;}
  .ui-select select { width: 110%; background-position: right 30px center !important; border: none !important;}
}
i.fas.fa-chevron-down {
    position: absolute;
    right: 22px;
    top: 18px;
    font-size: 17px;
    color: #abc0d8;
}

@media only screen and (max-width: 500px) {
  
}
</style>


// WEBPACK FOOTER //
// src/views/Referral/ReferralTiers.vue